<template>
	<div class="page-deals">

        <!------------------------------------------
            Brand Logos
        --------------------------------------------->
        <div v-if="showBrands">
            <TitleBar title="Shop by Brand" />
            <BrandLogoGrid :include="brands" :tag="$route.params.tag" />
        </div>

        <!------------------------------------------
            Deals Grid
        --------------------------------------------->
        <div>
            <TitleBar :title="pageTitle" :totalDeals="totalDeals" />

            <!------------------------------------------
                If loading
            --------------------------------------------->
            <div v-if="isLoading && deals.length < 1">
                loading deals
            </div>
            <div v-else>
                <Deals :deals="deals" v-if="deals.length > 0" />
                <LoadMore :isLoading="isLoading" @more="loadNextPage" v-if="deals.length < totalDeals" />
            </div>

        </div>
	</div>
</template>

<script>
import Deals from '../components/Deals.vue';
import TitleBar from '../components/TitleBar.vue';
import BrandLogoGrid from '../components/BrandLogoGrid.vue';
import LoadMore from '../components/LoadMore.vue';
import TagConfig from '../helpers/tag-config.js';
import BrandConfig from '../helpers/brand-config.js';

//
export default {
    created() {
        this.getDeals();
    },
	components: {
		Deals,
		TitleBar,
        BrandLogoGrid,
        LoadMore
	},
	data: function() {
		return {
            isLoading: true,
            totalDeals: 0,
			deals: [],
            page: 1,
            limit: 50
		}
	},
	computed: {
		pageTitle() {
            try {

                //if this is a search query
                if( this.$route.query.q ) {
                    return "Search Results";
                }

                //if this is a tag
                if( this.$route.name === 'Tag' ) {
                    return ["Deals tagged", this.$route.params.tag].join(" ");
                }

                //if this is a brand
                if( this.$route.name === 'Brand' ) {
                    return ["Deals from", this.$route.params.brand].join(" ");
                }

                //if this is a store
                if( this.$route.name === 'Store' ) {
                    return ["Deals from", this.$route.params.store].join(" ");
                }

                //if this is a brand and a tag
                if( this.$route.name === 'BrandWithTag' ) {
                    return [this.$route.params.tag, "from", this.$route.params.brand].join(" ");
                }

                //
                throw 0;
                
            }catch(e) {
                return "Deals";
            }
		},
        showBrands() {
            try {
                //check for show brands in tag config
                return ( this.$route.name == 'Tag' && TagConfig[this.$route.params.tag].showBrands ) ;
            }catch(e) {
                return false;
            }
        },
        brands() {
            try {
                return TagConfig[this.$route.params.tag].brands;
            }catch(e) {
                return [];
            }
        },
        from() {
            return ( this.page - 1 ) * this.limit;
        },
        params() {

            //
            let params = {
                limit: this.limit,
                from: this.from
            };


            /******************************************************
            * Add tag params
            ******************************************************/
            try {
                if( this.$route.params.tag ) {
                    //do we have a tag config? if so use it instead of the tag itself
                    if( typeof TagConfig[this.$route.params.tag] === 'object' ) {
                        params = Object.assign({}, params, TagConfig[this.$route.params.tag].params);
                    }else {
                        params.tag = this.$route.params.tag;
                    }
                }
            }catch(e) {}


            /******************************************************
            * Add brands params
            ******************************************************/
            try {
                if( this.$route.params.brand ) {
                    //do we have a brand config? if so use it instead of the brand itself
                    if( typeof BrandConfig[this.$route.params.brand] === 'object' ) {
                        params = Object.assign({}, params, BrandConfig[this.$route.params.brand].params);
                    }else {
                        params.brand = this.$route.params.brand;
                    }
                }
            }catch(e) {}


            /******************************************************
            * Add store params
            ******************************************************/
            try {
                if( this.$route.params.store ) {
                    params.store = this.$route.params.store;
                }
            }catch(e) {}


            /******************************************************
            * Add query params
            ******************************************************/
            try {
                if( this.$route.query.q ) {
                    params.keywords = this.$route.query.q;
                }
            }catch(e) {}


            //show me the params!
            // console.log(params);

            //
            return params;
        }
	},
	methods: {
        loadNextPage() {
            this.page++;
            this.getDeals();
        },
        getDeals() {

            //
            this.isLoading = true;

            //load deals
            this.$store.dispatch('getDeals', this.params)
                .then(deals => {
                    deals.data.forEach(deal => {
                        this.deals.push(deal);
                    });
                    this.totalDeals = deals.total;
                    this.isLoading = false;
                })
                .catch(e => {
                    this.isLoading = false;
                });

        }
    }
};
</script>

<style lang="scss">
</style>